import { Route, Routes } from 'react-router-dom';
import './App.css';
import ScrollToTop from './components/ScrollToTop';
import AboutPage from './pages/AboutPage';
import AdvisorProfilePage from './pages/AdvisorProfilePage';
import AdvisorSearchPage from './pages/AdvisorSearchPage';
import AdvisorsPage from './pages/AdvisorsPage';
import LandingPage from './pages/LandingPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/acerca" element={<AboutPage />} />
        <Route path="/privacidad" element={<PrivacyPage />} />
        <Route path="/terminos" element={<TermsPage />} />
        <Route path="/asesores" element={<AdvisorsPage />} />
        <Route path="/buscar" element={<AdvisorSearchPage />} />
        <Route path="/asesor/:publicId" element={<AdvisorProfilePage />} />
      </Routes>
    </>
  );
}

export default App;
